/**
 * 整箱询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type ShokzInquiryBaseModel,
  type ShokzInquiryFclVehicleVO,
  type ShokzInquiryPageRequest,
  type ShokzInquirySaveRequest,
  type ShokzInquiryAddressVO
} from './inquiry-base'

/**
 * 整箱询价模型（继承基础询价模型）
 */
export interface ShokzInquiryFclModel extends ShokzInquiryBaseModel {
  paymentType?: number | null
  originCountryIds?: string[] | null
  originCityIds?: string[] | null
  destinationCountryIds?: string[] | null
  destinationCityIds?: string[] | null
  prePortAddressType?: number | null
  prePortWarehouseId?: string | null
  cargoTransportMode?: number | null
  vehicleList?: ShokzInquiryFclVehicleVO[]
}

/**
 * 整箱询价分页查询请求参数
 */
export interface ShokzInquiryFclPageRequest extends ShokzInquiryPageRequest {}

/**
 * 整箱询价保存请求参数
 */
export interface ShokzInquiryFclSaveRequest extends ShokzInquirySaveRequest {
  paymentType?: number | null
  originCountryIds?: string[] | null
  originCityIds?: string[] | null
  destinationCountryIds?: string[] | null
  destinationCityIds?: string[] | null
  prePortAddressType?: number | null
  prePortWarehouseId?: string | null
  cargoTransportMode?: number | null
  vehicleList?: ShokzInquiryFclVehicleVO[]
}

/**
 * 分页查询整箱询价列表
 */
export const pageInquiryFcl = (params: ShokzInquiryFclPageRequest) => {
  return request.post<PageResponse<ShokzInquiryFclModel>>('/price/shokzInquiry/fcl/page', params)
}

/**
 * 根据ID获取整箱询价详情
 */
export const getInquiryFclById = (id: string) => {
  // 提取纯数字ID部分，去除可能的额外信息
  const pureId = id.split(/\s+/)[0];
  return request.post<ShokzInquiryFclModel>('/price/shokzInquiry/fcl/get', { id: pureId })
}

/**
 * 根据询价编号获取整箱询价详情
 */
export const getInquiryFclByInquiryNo = (inquiryNo: string) => {
  return request.post<ShokzInquiryFclModel>('/price/shokzInquiry/fcl/get', { inquiryNo })
}

/**
 * 新增整箱询价
 */
export const saveInquiryFcl = (params: ShokzInquiryFclSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/fcl/save', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 修改整箱询价
 */
export const updateInquiryFcl = (params: ShokzInquiryFclSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/fcl/update', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 更新已确认报价单ID
 */
export const updateConfirmedQuotation = (params: { id: string; confirmedQuotationId: string | null }) => {
  return request.post<boolean>('/price/shokzInquiry/fcl/update-confirmed-quotation', params)
}

/**
 * 批量删除整箱询价
 */
export const batchDeleteInquiryFcl = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/shokzInquiry/fcl/batch-delete', params)
}

/**
 * 发送询价邮件请求参数
 */
export interface ShokzInquirySendEmailRequest {
  inquiryId: string
  supplierContactIds: string[]
}

/**
 * 发送询价邮件给供应商联系人
 */
export const sendInquiryEmail = (params: ShokzInquirySendEmailRequest) => {
  return request.post<boolean>('/price/shokzInquiry/fcl/send-email', params)
}

// 类型别名（兼容老代码）
export type InquiryFclModel = ShokzInquiryFclModel
export type InquiryFclPageRequest = ShokzInquiryFclPageRequest
export type InquiryFclSaveRequest = ShokzInquiryFclSaveRequest
